import { HateoasResource, Resource } from '@lagoshny/ngx-hateoas-client';

@HateoasResource('contracts', { routeName: 'billingResourceRoute' })
export class Contract extends Resource {
    public id: string;
    public accountId: string;
    public provider: string;
    public providerId: string;
    public productId: string;
    public productName: string;
    public active: boolean;
    public status: string;
}
